<template>
    <div
        class="container-fluid w-100"
        style="overflow: hidden; min-height: 80vh"
    >
        <navbar
            :title="$t('menu.fuel_report')"
            class="mb-2"
        />
        <fuel-report-search
            :contracts="contracts"
            :is-loading="loading"
            @search="fetchFuelReports"
        />
        <div
            id="fuelReportResultContainer"
            class="col-sm-12 nopads"
        >
            <div
                v-if="reportSummary"
                class="col-12 nopads pb-1"
                style="background: #FFFFFF; box-shadow: #d9d9d9 1px 1px 4px; border-radius: .5em"
            >
                <div
                    class="m-2 p-2"
                >
                    <div class="row">
                        <div class="col-3">
                            <span class="stat-title">{{ $t('trip.vehicle_count')  }}</span>
                            <span class="stat-text"> {{ reportSummary.vehicles }} </span>
                        </div>
                        <div class="col-3">
                            <span class="stat-title">{{ $t('trip.total_distance') }}</span>
                            <span class="stat-text"> {{ reportSummary.km }} km </span>
                        </div>
                        <div class="col-3">
                            <span class="stat-title">{{ $t('trip.total_duration') }}</span>
                            <span class="stat-text"> {{ getWorkTime(reportSummary.duration) }} </span>
                        </div>
                        <div class="col-3">
                            <span class="stat-title">{{ $t('trip.total_fuel') }}</span>
                            <span class="stat-text"> {{ reportSummary.liters?.toFixed(2) }} l </span>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end">
                    <button
                        v-if="fuelReports && fuelReports.length > 0"
                        class="btn btn-outline-success form-button m-2 justify-content-end"
                        @click="exportExcel"
                    >
                        {{ $t('common.download_excel') }}
                    </button>
                </div>
            </div>
            <!-- Trip list part with scrollable content -->
            <fuel-report-list
                class="mt-2"
                ref="fuelReportList"
                :fuel-reports="fuelReports"
            />
        </div>
    </div>
</template>

<script>
import Navbar from "@/components/utils/Navbar.vue";
import FuelReportSearch from "@/components/trip/fuelreport/FuelReportSearch.vue";
import {restApi} from "@/components/mixins/RestApiMixin.js";
import {timeUtils} from "@/components/mixins/TimeUtils.js";
import FuelReportList from "./FuelReportList.vue";
import {downloadHelper} from "@/components/mixins/DownloadMixin.js";

export default {
    name: "FuelReport",
    components: {FuelReportList, FuelReportSearch, Navbar},
    mixins: [restApi, timeUtils, downloadHelper],
    data () {
        return {
            loading: false,
            contracts: null,
            fuelReports: [],
            reportParams: null,
            reportSummary: null
        }
    },
    mounted () {
        this.fetchContracts()
    },
    methods: {
        async fetchFuelReports(params) {
            this.loading = true;
            this.reportParams = params;
            await this.restFetchParams(this.fuelReportUrl, params, this.success, this.fail);
        },
        success (response) {
            this.fuelReports = response.data;
            this.setReportSummary()
            this.loading = false;
        },
        setReportSummary() {
            const summary = {
                vehicles: this.fuelReports.length,
                km: 0,
                liters: 0,
                duration: 0
            };

            this.fuelReports.forEach(report => {
                summary.km += report.total_distance || 0;
                summary.duration += report.total_minutes || 0;
                summary.liters += report.total_liters || 0;
            });

            this.reportSummary = {
                vehicles: summary.vehicles,
                km: Math.round(summary.km * 1000) / 1000,
                liters: summary.liters,
                duration: Math.round(summary.duration)
            };
        },
        fail (response) {
            this.showAlert(this.$t('trip_list.err_general'))
            this.loading = false;
        },
        fetchContracts: function () {
            this.loading = true;
            let params = {}
            params.startDate = this.getStartOfTheDay(new Date())
            params.endDate = this.getEndOfTheDay(new Date())
            this.restFetchParams(this.contractOpenUrl, params, this.contractsSuccess, this.fetchFail)
        },
        contractsSuccess: function (response) {
            this.contracts = response.data
            this.loading = false
        },
        fetchFail: function () {
            this.loading = false
        },
        async exportExcel() {
            this.loading = true;
            const { err, ...response } = await this.fetchExcel().catch((err) => ({err}));
            this.loading = false;
            if (err) {
                this.showAlert(this.$t('common.report_generation_failed'))
                return;
            }
            this.downloadFile(response, this.$t('trip.fuel_report_file_name'))
        },
        fetchExcel: function() {
            return this.axios.get(
                this.fuelReportExcelUrl,
                {
                    params: this.getCommonReportParams(this.reportParams),
                    responseType: 'arraybuffer'
                }
            )
        }
    }
}
</script>
